/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'unavailable': {
    width: 187,
    height: 178,
    viewBox: '0 0 187 178',
    data: '<path pid="0" d="M125.01 82.278l-12.02-11.985L93.5 89.728 74.01 70.293 61.99 82.278l19.49 19.436-19.49 19.436 12.02 11.986L93.5 113.7l19.49 19.436 12.02-11.986-19.49-19.436zM170 16.952h-25.5V0h-17v50.857h17V33.905H170v127.143H17V33.905h17V16.952H17A16.976 16.976 0 000 33.905v127.143A16.976 16.976 0 0017 178h153a16.976 16.976 0 0017-16.952V33.905a16.976 16.976 0 00-17-16.953zm-51 0H59.5V0h-17v50.857h17V33.905H119V16.952z" fill-rule="evenodd"/>'
  }
})
